<template>
  <v-row class="main global">
    <v-col cols="12" class="main-body">
      <h2 class="primary--text font-weight-medium pb-2">
        {{ facilityTemplate.title }}
      </h2>
      <template v-if="facilityTemplate.longImage">
        <v-img :src="facilityTemplate.longImage"></v-img>
        <p class="caption">{{ facilityTemplate.imageCaptionText }}</p>
      </template>
      <v-row class="px-3 primary">
        <v-card
          v-for="index in facilityTemplate.facilityFactoids.length"
          :key="`factoid-${index}`"
          width="50%"
          flat
          tile
          color="primary"
        >
          <v-card-text>
            <h5 class="white--text">
              {{ getFactoid(index - 1, 'label') }}
            </h5>
            <p class="white--text">
              {{ getFactoid(index - 1, 'value') }}
            </p>
          </v-card-text>
        </v-card>
      </v-row>
      <v-row class="about-project" v-if="facilityTemplate.facilityOverviewText">
        <v-col>
          <p class="primary--text mb-1">About the Project</p>
          <p class="body-2 pre-wrap">
            {{ facilityTemplate.facilityOverviewText }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="primary--text mb-1">
            About {{ facilityTemplate.primaryCompany }}
          </p>
          <p class="mb-1 body-2 pre-wrap">
            {{ facilityTemplate.companyInfos[facilityTemplate.primaryCompany] }}
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import numeralHelper from '@/helpers/NumeralHelper';
import { mapState, mapGetters } from 'vuex';
import factsheetLogic from '@/mixins/factsheetLogic';

export default {
  name: 'FacilityFactsheet',
  mixins: [factsheetLogic],
  computed: {
    ...mapState({
      facilityTemplate: 'facilityTemplate'
    })
  },
  methods: {
    getValue(field) {
      const facilityData = this.facilityTemplate.facilityData;
      if (facilityData) {
        return facilityData[field];
      }
      return;
    },
    getFactoid(i, field) {
      const factoids = this.facilityTemplate.facilityFactoids;
      if (factoids.length >= i + 1) {
        if (field === 'label') {
          return factoids[i].label;
        }

        const value = this.getValue(factoids[i].field);
        if (value && factoids[i].value.endsWith('null')) {
          return 'In Development/Construction';
        } else {
          return factoids[i].value;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  color: $ne-textcolor;
  p.body-2 {
    line-height: 1.125;
  }
}
.v-card {
  &:nth-child(1),
  &:nth-child(2) {
    p {
      margin-bottom: 0;
    }
  }
}
.v-card__text {
  font-size: 1rem;
}
.pre-wrap {
  white-space: pre-line;
  word-wrap: break-word;
  font-family: inherit;
}

.about-project {
  .col {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
  }
}
</style>
